import React, { Component } from 'react'
import { Input, Select } from 'antd'
import './index.css'

export default class index extends Component {
  onInputChange = (e) => {
    console.log(parseFloat(e.target.value) || '')
    const value = parseFloat(e.target.value) || ''
    this.props.inputChange(value)
  }

  render() {
    const { required, key, title, type, value, suffix, disabled, options } =
      this.props.item
    const dataType = this.props.tutorTypeInfo
      ? this.props.tutorTypeInfo[0].value
      : ''
    return (
      <div className="text-input-view">
        {required && <span className="red-span">*</span>}
        <span
          className={`title-input-class ${
            disabled ? 'disabled-input-title-color' : ''
          }`}
        >
          {title}
        </span>
        {!options && (
          <React.Fragment>
            <Input
              id={key}
              className={`write-input-class ${
                disabled ? 'disable-write-input-color' : ''
              }`}
              disabled={disabled}
              type={type ? type : 'text'}
              placeholder={`请输入${title}`}
              value={value}
              maxLength={type && type === 'password' ? 20 : 18}
              onChange={this.props.inputChange}
            ></Input>
            {suffix.length > 0 && (
              <span
                className={`suffix-input-class ${
                  disabled ? 'disabled-input-title-color' : ''
                }`}
              >
                {suffix}
              </span>
            )}
          </React.Fragment>
        )}
        {options && options.length > 0 && (
          <Input.Group compact>
            <Input
              id={key}
              className="disable-write-input-color"
              disabled={disabled}
              type={type ? type : 'text'}
              placeholder={`请输入${title}`}
              value={value}
              maxLength={type && type === 'password' ? 20 : 18}
              onChange={this.props.inputChange}
              style={{
                width: '60%',
              }}
              size="large"
            ></Input>
            <Select
              defaultValue={this.props.selectValue?this.props.selectValue:1}
              style={{
                width: '40%',
                backgroundColor: '#e9e9e9',
                lineHeight: '38px',
              }}
              size="large"
              className="compact_select"
              disabled={disabled}
              onChange={this.props.selectChange}
            >
              <Select.Option value={1}>
                {dataType === '' || dataType === 1 ? '元 / 小时' : '元 / 课程'}
              </Select.Option>
              <Select.Option value={2}>%(按实收金额百分比)</Select.Option>
            </Select>
          </Input.Group>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/textInputView/index.js